export default __webpack_public_path__ + "static/media/878.812aec35.png";